import type { WizardStepDto, WizardStepKey } from '@bk/contracts';
import type { ComponentType } from 'react';
import { Fase1Page } from './Fase1';
import { Fase10Page } from './Fase10';
import { Fase11Page } from './Fase11';
import { Fase2Page } from './Fase2';
import { Fase3Page } from './Fase3';
import { Fase4Page } from './Fase4';
import { Fase5Page } from './Fase5';
import { Fase6Page } from './Fase6';
import { Fase7Page } from './Fase7';
import { Fase8Page } from './Fase8';
import { Fase9Page } from './Fase9';

/** Ciò che ogni pagina di fase riceve dal percorso. */
export interface PhasePageProps {
  next: WizardStepDto | null;
  onNext: () => void;
  sealing: boolean;
  stopped?: boolean;
}

/**
 * Il registro delle pagine di fase del servizio delle fasi (ADR 0174): il passo della configurazione e la sua pagina.
 * Una fase nuova (4-11) aggiunge qui la sua riga; il percorso (`Wizard.tsx`) non cambia.
 */
export const PHASE_PAGES: Partial<Record<WizardStepKey, ComponentType<PhasePageProps>>> = {
  impresa: Fase1Page,
  sedi: Fase2Page,
  attivita: Fase3Page,
  processi: Fase4Page,
  impianti: Fase5Page,
  obblighi: Fase6Page,
  software: Fase7Page,
  organizzazione: Fase8Page,
  procedure: Fase9Page,
  diagnosi: Fase10Page,
  proposte: Fase11Page,
};
